import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgList = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 3.9,
			y1: 13.1,
			x2: 10.1,
			y2: 13.1,
			stroke: "#8C94AA",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 3.9,
			y1: 8.1,
			x2: 14.1,
			y2: 8.1,
			stroke: "#8C94AA",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 3.9,
			y1: 3.1,
			x2: 14.1,
			y2: 3.1,
			stroke: "#8C94AA",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgList);
export default ForwardRef;
